export default __webpack_public_path__ + "static/media/connect.9cfe9dbc.png";